import _Object$keys from 'babel-runtime/core-js/object/keys';

import CrmRelativeTable from './CrmRelativeTable';
import { objDeepCopy } from '@/utils';

export default {
  name: 'CrmRelatieve', // 相关
  components: {
    CrmRelativeTable: CrmRelativeTable
  },
  props: {
    /** 多选框 只能选一个 */
    radio: {
      type: Boolean,
      default: true
    },
    acceptEmail: {
      type: String,
      default: ''
    },
    /** 没有值就是全部类型 有值就是当个类型 */
    crmType: {
      type: String,
      default: ''
    },
    /** 需要展示哪些类型 默认关键字数组 */
    showTypes: {
      type: Array,
      default: function _default() {
        return ['customer', 'contacts', 'leads', 'business', 'contract', 'product'];
      }
    },
    /** 已选信息 */
    selectedData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    /** true 的时候 发请求 */
    show: {
      type: Boolean,
      default: true
    },
    /**
     * default 默认  condition 固定条件筛选 moduleType 下的
     * relative: 相关 添加
     */
    action: {
      type: Object,
      default: function _default() {
        return {
          type: 'default',
          data: {}
        };
      }
    }
  },
  data: function data() {
    return {
      leftType: 'customer',
      leftSides: [],
      /** 各类型选择的值 */
      currentSelectedData: {}
    };
  },

  computed: {},
  watch: {
    selectedData: function selectedData(data) {
      this.handleCurrentSelectData(data);
    },
    // 刷新标记
    show: function show(val) {
      if (val) {
        this.handleCurrentSelectData(this.selectedData);
      }
    }
  },
  mounted: function mounted() {
    var leftItems = {
      customer: {
        name: '客户',
        type: 'customer'
      },
      contacts: {
        name: '联系人',
        type: 'contacts'
      },
      leads: {
        name: '线索',
        type: 'leads'
      },
      business: {
        name: '商机',
        type: 'business'
      },
      contract: {
        name: '合同',
        type: 'contract'
      },
      product: {
        name: '产品',
        type: 'product'
      },
      invoiceTitle: {
        name: '发票抬头',
        type: 'invoiceTitle'
      }
    };
    if (this.crmType) {
      this.leftType = this.crmType;
      this.leftSides.push(leftItems[this.crmType]);
    } else {
      for (var index = 0; index < this.showTypes.length; index++) {
        var element = this.showTypes[index];
        this.leftSides.push(leftItems[element]);
      }
    }
    this.currentSelectedData = objDeepCopy(this.selectedData);
  },

  methods: {
    /**
     * 目前选择值
     */
    handleCurrentSelectData: function handleCurrentSelectData(data) {
      if (data && _Object$keys(data).length) {
        this.currentSelectedData = objDeepCopy(data);
      } else {
        var tempData = {};
        if (this.crmType) {
          tempData[this.crmType] = [];
          this.currentSelectedData = tempData;
        } else {
          for (var index = 0; index < this.showTypes.length; index++) {
            var key = this.showTypes[index];
            tempData[key] = [];
          }
          this.currentSelectedData = tempData;
        }
      }
    },


    /**
     * 刷新列表
     */
    refreshList: function refreshList() {
      this.$refs['crm' + this.crmType][0].refreshList();
    },
    sideClick: function sideClick(item) {
      this.leftType = item.type;
    },
    clearAll: function clearAll() {
      if (this.crmType) {
        this.$refs['crm' + this.crmType][0].clearAll();
      }
    },


    /**
     * 当用户手动勾选全选 Checkbox 时触发的事件
     */
    selectAll: function selectAll() {},


    /**
     * 关闭操作
     */
    closeView: function closeView() {
      this.$emit('close');
    },
    checkCrmTypeInfos: function checkCrmTypeInfos(data) {
      this.currentSelectedData[data.type] = data.data;
    },


    /**
     * 确定选择
     */
    confirmClick: function confirmClick() {
      if (this.crmType) {
        if (this.acceptEmail == 'receive') {
          this.$emit('changeCheckout', { data: this.currentSelectedData[this.crmType], type: 'receive' });
        } else if (this.acceptEmail == 'sent') {
          this.$emit('changeCheckout', { data: this.currentSelectedData[this.crmType], type: 'sent' });
        } else {
          // 以单类型传值
          this.$emit('changeCheckout', {
            data: this.currentSelectedData[this.crmType] ? this.currentSelectedData[this.crmType] : []
          });
        }
      } else {
        this.$emit('changeCheckout', { data: this.currentSelectedData });
      }

      this.$emit('close');
    },


    /**
     * 获取菜单数量
     */
    getMenuCrmNum: function getMenuCrmNum(type) {
      return this.currentSelectedData[type] ? this.currentSelectedData[type].length : 0;
    },


    /**
     * 根据类型获取标题展示名称
     */
    getTitle: function getTitle() {
      if (this.crmType == 'leads') {
        return '关联线索模块';
      } else if (this.crmType == 'customer') {
        return '关联客户模块';
      } else if (this.crmType == 'contacts') {
        return '关联联系人模块';
      } else if (this.crmType == 'business') {
        return '关联商机模块';
      } else if (this.crmType == 'product') {
        return '关联产品模块';
      } else if (this.crmType == 'contract') {
        return '关联合同模块';
      } else if (this.crmType == 'invoiceTitle') {
        return '关联发票抬头';
      } else {
        return '关联相关信息';
      }
    }
  }
};